// import { Component } from 'react';
import { useEffect, useState, useRef } from 'react'
import Loading from './LoadingComponent';
import PaginationComponent from './PaginationComponent';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import { Link } from 'react-router-dom';
import DialogContentText from '@material-ui/core/DialogContentText';
import {formatHTML, findById, findInArray, formatDate} from '../data/utils';
import {formatDateTime} from '../data/utils'
import TechAppDialog from './TechAppDialog';
import Chip from '@material-ui/core/Chip';
import * as MdIcons from "react-icons/md";
import { loadWOs } from '../data/wos';
import WOFilter from '../data/types';
import {copyDict} from '../data/utils';
import './css/workorders.css';
import SpecialInstructionComponent from './SpecialInstructionsComponent';

type ChipsFilterProperties = {
    WOFilter: WOFilter,
    woTypes: [],
    onFilterRemoved(key: string): void;
}

function ChipsFilter(props: ChipsFilterProperties){
    let wo_states = [
        ['new', 'Requested'],
        ['parts_allocated', 'Parts'],
        ['schedule', 'Scheduling'],
        ['assigned', 'Assigned'],
        ['need_to_return', 'Need To Return'],
        ['on_hold', 'On Hold'],
        ['cancel', 'Canceled'],
        ['complete', 'Complete'],
        ['finalized', 'Finalized'],
        ['to_be_invoiced', 'To Be Invoiced'],
        ['invoiced', 'Invoiced'],
    ]
    let chips = [];
    if(props.WOFilter.my_open_time || props.WOFilter.my_open_labor || props.WOFilter.my_open_travel){
        if(props.WOFilter.my_open_time)
            chips.push({key: 'my_open_time', text: 'My Open Time'});
        if(props.WOFilter.my_open_labor)
            chips.push({key: 'my_open_labor', text: 'My Open Labor'});
        if(props.WOFilter.my_open_travel)
            chips.push({key: 'my_open_travel', text: 'My Open Travel'});
    }
    else{
        if(props.WOFilter.myAssignments)
            chips.push({key: 'myassignments', text: 'My Assignments'});
        if(props.WOFilter.date_filter === 'today')
            chips.push({key: 'date', text: 'Today'});
        else if(props.WOFilter.date_filter === 'tomorrow')
            chips.push({key: 'date', text: 'Tomorrow'});
        else if(props.WOFilter.date_filter === 'this_week')
            chips.push({key: 'date', text: 'This Week'});
        else if(props.WOFilter.date_filter === 'next_week')
            chips.push({key: 'date', text: 'Next Week'});
        else if(props.WOFilter.date_filter === 'this_month')
            chips.push({key: 'date', text: 'This Month'});
        else if(props.WOFilter.date_filter === 'custom')
            chips.push({key: 'date', text: `Date Range: ${formatDate(props.WOFilter.date_start)} - ${formatDate(props.WOFilter.date_end)}`});
        if(parseInt(props.WOFilter.wo_type) > 0){
            const typeName = findById(parseInt(props.WOFilter.wo_type), props.woTypes);
            chips.push({key: 'wo_type', text: `WO Type: ${typeName}`});
        }
        if(props.WOFilter.wo_state !== '' && props.WOFilter.wo_state !== '0'){
            const stateName = findInArray(props.WOFilter.wo_state, wo_states);
            chips.push({key: 'wo_state', text: `WO State: ${stateName}`});
        }
        if(props.WOFilter.all_parts_ready){
            chips.push({key: 'all_parts_ready', text: 'All Parts Ready'});
        }
        if(props.WOFilter.search_name)
            if(props.WOFilter.search_by === 'wo')
                chips.push({key: 'by_name', text: `WO: ${props.WOFilter.search_name}`});
            else
                chips.push({key: 'by_name', text: `Asset: ${props.WOFilter.search_name}`});
    }
    const chipsTags = chips.map((chip) => {
        return (<Chip key={chip.key} label={chip.text} onDelete={() => {props.onFilterRemoved(chip.key)}} className="chips_filter"></Chip>)
    });
    return (<div>{chipsTags}</div>);
}

type WorkOrderProperty = {
    workorder: any;
    onDescIconClick(workorder: any): void;
    onEventLinkClick(workorder: any): void;
}

function WorkOrder(props: WorkOrderProperty){
    const workorder = props.workorder;
    let job_progress_class = workorder.wo_job_progress === 'labor' ? 'wo_job_progress_labor' :
            (workorder.wo_job_progress === 'travel' ? 'wo_job_progress_travel' : 'wo_job_progress_nowork');
    job_progress_class += ' wo_job_progress';
    return (<Paper className="woitem" elevation={3} key={workorder.id}>
            <div className="woitem_header">
                <div className={job_progress_class}></div>
                {
                workorder.wo_id ?
                (<Link to={`/wo/${workorder.wo_id}`}>{workorder.name}</Link>):
                (<Link to={"#"} onClick={() => props.onEventLinkClick(workorder)}>{workorder.name}</Link>)
                }
                <Typography variant="subtitle2">{workorder.state}</Typography>
                {workorder.assigned_date? (<Typography variant="subtitle2">{formatDateTime(new Date(workorder.assigned_date))}</Typography>) : (<></>)}
            </div>
                <hr/>
            <div className="woitem_body">
                {workorder.wo_id ?
                (<>
                    <div>
                        <SpecialInstructionComponent workorder={workorder}/>
                    </div>
                    <div>
                    <Typography variant="subtitle2">Type:</Typography><Typography variant="body2">{workorder.wo_type}</Typography>
                    </div>
                    <div>
                    <Typography variant="subtitle2">Asset:</Typography><Typography variant="body2">{workorder.asset_name}</Typography>
                    </div>
                    {
                    workorder.site_gate_code?
                    (<div>
                    <Typography variant="subtitle2">Gate Code:</Typography><Typography variant="body2">{workorder.site_gate_code}</Typography>
                    </div>):(<></>)
                    }
                    <div>
                    <Typography variant="subtitle2">Customer:</Typography><Typography variant="body2">{workorder.customer_name}</Typography>
                    </div>
                    <div>
                    <Typography variant="subtitle2">Parts Ready:</Typography><Typography variant="body2">
                        {workorder.has_all_parts_ready_to_pick} ({workorder.parts_ready_count} / {workorder.parts_count})</Typography>
                    </div>
                    <div>
                    <Typography variant="subtitle2">Parts Picked:</Typography><Typography variant="body2">({workorder.parts_picked_count} / {workorder.parts_count})</Typography>
                    </div>
                    <div>
                        <Typography variant="subtitle2">Temp Shelf:</Typography><Typography variant="body2">{workorder.temp_shelves.map((shelf: any) => shelf.name).join(', ')}</Typography>    
                    </div>
                    <div>
                    <Typography variant="subtitle2"># Techs:</Typography><Typography variant="body2">{workorder.techs_count}</Typography>
                    </div>
                </>):(<>
                    <div dangerouslySetInnerHTML={{ __html: formatHTML(workorder.description) }} className="event_description"/>
                </>)
                }
            </div>
            </Paper>);
}

type EventDataProperties = {
    open: boolean;
    workorder: any;
    onClose(): void;
}

function EventDataDialog(props: EventDataProperties){
    return (<TechAppDialog open={props.open} title="Event" onClose={props.onClose} closeOnClickOutside={true}>
        <DialogContentText>
                <Typography variant="subtitle2">{props.workorder.name}</Typography>
                <Typography>{formatDateTime(new Date(props.workorder.assigned_date))}</Typography>
                <div dangerouslySetInnerHTML={{ __html: formatHTML(props.workorder.description) }} className="event_description"/>
            </DialogContentText>
    </TechAppDialog>);
}


type WOsProperties = {
    WOFilter: WOFilter,
    woTypes: [],
    onFilterUpdate(WOFilter: WOFilter): void;
    onMount(mounted: boolean): void;
    onError(error: any): void;
}
export default function Workorders(props: WOsProperties) {
    const [eventModalOpen, setEventModalOpen] = useState(false);
    const [selectedWorkOrder, setSelectedWorkOrder] = useState<any>(false);
    const [workorders, setWorkorders] = useState<any[]>([]);
    const [workordersCount, setWorkordersCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [pageIndex, setPageIndex] = useState(0);
    const [pageSize] = useState(25);

    const loadWOsHandler = async (pageIndex: number, filter: WOFilter) => {
        try {
            setLoading(true);
            const result = await loadWOs(filter, pageIndex * pageSize, pageSize);
            // If loadWOs returns void, do nothing. If it returns an object, update state.
            if (result && typeof result === 'object') {
                setWorkorders(result.wos || []);
                setWorkordersCount(result.wos_count || 0);
            }
            setLoading(false);
        } catch (err: any) {
            console.log('Error', err);
            setLoading(false);
            props.onError(err);
        }
    };

    const onPageChanged = (newPageIndex: number) => {
        setPageIndex(newPageIndex);
    };

    useEffect(() => {
        console.log('Component mounted');
        props.onMount(true);
        return () => {
            props.onMount(false);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        console.log('WOFilter state changed', props.WOFilter);
        loadWOsHandler(pageIndex, props.WOFilter);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageIndex, props.WOFilter]);

    const removeFilter = (filter: string) => {
        let newWOFilter = copyDict(props.WOFilter);
        if (filter === 'myassignments')
            newWOFilter.myAssignments = false;
        else if (filter === 'date') {
            newWOFilter.date_filter = 'none';
        }
        else if (filter === 'wo_type')
            newWOFilter.wo_type = '0';
        else if (filter === 'wo_state')
            newWOFilter.wo_state = '0';
        else if (filter === 'by_name')
            newWOFilter.search_name = '';
        else if (filter === 'my_open_labor')
            newWOFilter.my_open_labor = false;
        else if (filter === 'my_open_travel')
            newWOFilter.my_open_travel = false;
        else if (filter === 'my_open_time')
            newWOFilter.my_open_time = false;
        else if (filter === 'all_parts_ready')
            newWOFilter.all_parts_ready = false;
        props.onFilterUpdate(copyDict(newWOFilter));
    };

    const onDescIconClick = (workorder: any) => {
        setSelectedWorkOrder(workorder);
    };

    const onEventLinkClick = (workorder: any) => {
        setEventModalOpen(true);
        setSelectedWorkOrder(workorder);
    };

    const closeModal = () => {
        setEventModalOpen(false);
    };

    if (loading) {
        return (<Loading loading={loading} fullWidth={true} />);
    }
    const items = workorders.map((workorder: any) => {
        return (<WorkOrder key={workorder.id} workorder={workorder}
            onDescIconClick={onDescIconClick}
            onEventLinkClick={onEventLinkClick}
        />);
    });
    return (
        <div className="main_component_container">
            <EventDataDialog open={eventModalOpen} workorder={selectedWorkOrder}
                onClose={closeModal}></EventDataDialog>
            <div className="componentheader workorders_header">
                <ChipsFilter WOFilter={props.WOFilter} woTypes={props.woTypes} onFilterRemoved={removeFilter} />
                <IconButton onClick={() => { loadWOsHandler(pageIndex, props.WOFilter); }}><MdIcons.MdRefresh className="refresh_icon" /></IconButton>
            </div>
            {items}
            <PaginationComponent
                pageIndex={pageIndex}
                itemsCount={workordersCount}
                onPageChanged={onPageChanged}
            />
        </div>
    );
}